import { requestPdfDownload } from "../../requests/pdfDownloadRequest";
import { extractPdfContent } from "./extractPdfContent";

const DEFAULT_FILENAME = "pump-sizing.pdf";

function triggerBrowserDownload(blob: Blob, filename = DEFAULT_FILENAME): void {
	const downloadUrl = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = downloadUrl;
	link.download = filename;
	link.rel = "noopener";
	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(downloadUrl);
}

export async function downloadPumpSizingPdf(savedResultId?: string): Promise<void> {
	const content = extractPdfContent(savedResultId);
	const blob = await requestPdfDownload(content);
	triggerBrowserDownload(blob);
}
